import AdminDataTable from "../../core/DataTable/DataTable";

export function ZahraMemoriesList() {
    return <AdminDataTable collection="memories" columns={[
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Description",
            field: "description",
            type: "text",
        },
        {
            name: "Image",
            field: "image",
            type: "image",
        },
        {
            name: "Video",
            field: "video",
            type: "file",
            show: false,
            edit: true,
        },
        {
            name: "Date",
            field: "date",
            type: "date",
        },
        {
            name: "Created At",
            field: "createdAt",
            type: "datetime",
            edit: false,
        },
        {
            name: "Updated At",
            field: "updatedAt",
            type: "datetime",
            edit: false,
        },
    ]} />
}
